// extracted by mini-css-extract-plugin
export var swiper = "styles-module--swiper--fdogF";
export var img = "styles-module--img--WMEQL";
export var textContainer = "styles-module--textContainer--1hxwe";
export var headline = "styles-module--headline--7Ni6e";
export var headlineAnimation = "styles-module--headlineAnimation--6EBSw";